<div style="width: 90vw; height: 90vh">
  <div class="h7-heading mb-2">
    Перегляд розподілу
  </div>

  <div class="table-wrapper" style="height: 80vh">
    <p-table
      #dt
      styleClass="p-datatable-sm"
      [scrollable]="true"
      scrollHeight="flex"
      [value]="distribution?.rows ?? []"
      [customSort]="true"
      [lazy]="true"
      [resizableColumns]="true">

      <ng-template pTemplate="header">

        <tr>
          <th colspan="1" rowspan="2" class="h10-text">
            №
            <br/>з/п
          </th>
          <th colspan="2" rowspan="2" class="h10-text">
            Адміністративно-територіальні <br/>одиниці/Заклад охорони здоров’я
          </th>

          <ng-container *ngFor="let mnn of distribution?.header;">
            <ng-container *ngIf="+mnn.multiple <=1; else defaultTemplate">
              <th colspan="2" class="h10-text-center" [innerHTML]="formatHeaderText(mnn)"></th>
            </ng-container>
            <ng-template #defaultTemplate>
              <th colspan="3" class="h10-text-center" [innerHTML]="formatHeaderText(mnn)"></th>
            </ng-template>
          </ng-container>

          <th colspan="2" class="h10-text"></th>
        </tr>
        <tr>
          <ng-container *ngFor="let mnn of distribution?.header;">
            <ng-container *ngIf="+mnn.multiple <= 1; else defaultTemplate">
              <th class="h10-text-center">
                к-сть флаконів
              </th>
              <th class="h10-text-center">
                в-сть, грн
              </th>
            </ng-container>
            <ng-template #defaultTemplate>
              <th class="h10-text-center">
                к-сть капсул
              </th>
              <th class="h10-text-center">
                к-сть упаковок
              </th>
              <th class="h10-text-center">
                в-сть, грн
              </th>
            </ng-template>
          </ng-container>

          <th colspan="2" class="h10-text-center">
            Загальна вартість, грн
          </th>
        </tr>

      </ng-template>

      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr class="table-content-text">

          <ng-container *ngIf="row.isFinal else defaultTemplate">
            <!-- row.isFinal is true -->
            <td colspan="3" class="h10-text black-80">
              Всього
            </td>
          </ng-container>
          <ng-template #defaultTemplate>
            <!-- Default HTML for other cases -->
            <td class="h10-text black-80">
              {{ i + 1 }}
            </td>
            <td colspan="2" class="h10-text black-80">
              {{ row.regionName }}
            </td>
          </ng-template>

          <ng-container *ngFor="let mnnData of row?.mnNdataList;">
            <ng-container *ngIf="mnnData.multiple > 1 else defaultTemplate">
              <!-- HTML for when mnnData.multiple > 1 -->
              <td class="h10-text-center black-60">
                {{ mnnData.quantity }}
              </td>
              <td class="h10-text-center black-80">
                {{ mnnData.multiple }}
              </td>
              <td class="h10-text-center black-80">
                {{ mnnData.formattedPrice }}
              </td>
            </ng-container>
            <ng-template #defaultTemplate>
              <!-- Default HTML for other cases -->
              <td class="h10-text-center black-60">
                {{ mnnData.quantity }}
              </td>
              <td class="h10-text-center black-80">
                {{ mnnData.formattedPrice }}
              </td>
            </ng-template>
          </ng-container>




          <td colspan="2" class="h10-text-center black-80">
            {{ row.sum }}
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>

</div>
